import axios from 'axios'
import router from '@/router'

const Axios = axios.create({
  baseURL: '/v1',
  timeout: 10000
})

Axios.interceptors.request.use(config => {
  if (localStorage.bearer) {
    config.headers.Authorization = 'Bearer ' + localStorage.bearer
  }
  return config
}, error => {
  return Promise.reject(error)
})

Axios.interceptors.response.use(res => {
  if (res.data.errCode !== 0) {
    if (res.data.errCode === 40001 || res.data.errCode === 40005) {
      localStorage.removeItem('bearer')
      router.replace({path: '/login'})
    }

    return Promise.reject(res.data)
  }
  return res.data
}, error => {
  return Promise.reject(error.response.data)
})

export default Axios

// export default {
//   install (Vue) {
//     Object.defineProperty(Vue.prototype, '$http', { value: Axios })
//   }
// }



// WEBPACK FOOTER //
// ./src/libs/AxiosPlugin.js